import { dealConstants } from "../constants/dealConstants";
import { dealService } from "../../services/API/dealService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";
import { categoryConst } from "../constants/categoryConst";
import { categoryService } from "../../services/API/categoryService";

export const dealActions = {
  getDealList,
  getProductList,
  getAuctionList,
  getDealPending,
  getProductPending,
  getAuctionPending,
  getDealUpcoming,
  getProductUpcoming,
  getAuctionUpcoming,
  getDealPast,
  getProductPast,
  getAuctionPast,
  deleteDeal,
  getDealDetail,
  getAllCategory,
  editDealList,
  editProductList,
  editAuctionList,
  addDealLocation,
  getDealCities,
  deleteImage,
  getOrderDeatil,
  confirmClose,
  uploadExternalVoucher,
  getOrderDeals,
  saveOrderDeal,
  getExternalVoucher,
  uploadImage,
  updateDealImgOrdering,
  getDealSchedule,
  getProductSchedule,
  getAuctionSchedule,
  updateQuantity,
  getChildDeals,
};

function getOrderDeals(formData) {
  return dispatch => {
    dealService.getOrderDeals(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(dealList) {
    return { type: dealConstants.GET_ORDER_DEALS_REQUEST, dealList };
  }
  function success(dealList) {
    return { type: dealConstants.GET_ORDER_DEALS_SUCCESS, dealList };
  }
  function failure(error) {
    return { type: dealConstants.GET_ORDER_DEALS_FAILURE, error };
  }
};

function saveOrderDeal(formData) {
  return dispatch => {
    dealService.saveOrderDeal(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.SAVE_ORDER_DEALS_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.SAVE_ORDER_DEALS_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.SAVE_ORDER_DEALS_FAILURE, error };
  }
};

export const editDealList = formData => {
  return dispatch => {
    dealService.editDealList(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.EDIT_DEALLIST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.EDIT_DEALLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.EDIT_DEALLIST_FAILURE, error };
  }
};

export const editProductList = formData => {
  return dispatch => {
    dealService.editProductList(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.EDIT_DEALLIST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.EDIT_DEALLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.EDIT_DEALLIST_FAILURE, error };
  }
};

export const editAuctionList = formData => {
  return dispatch => {
    dealService.editAuctionList(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.EDIT_DEALLIST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.EDIT_DEALLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.EDIT_DEALLIST_FAILURE, error };
  }
};

export const updateDealImgOrdering = postData => {
  return dispatch => {
    dealService.updateDealImgOrdering(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.UPDATE_DEAL_IMG_ORD_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.UPDATE_DEAL_IMG_ORD_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.UPDATE_DEAL_IMG_ORD_FAILURE, error };
  }
};

export const uploadImage = postData => {
  return dispatch => {
    dealService.uploadImage(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.UPLOAD_IMAGE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.UPLOAD_IMAGE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.UPLOAD_IMAGE_FAILURE, error };
  }
};

export const addDealLocation = (formdata, dealID) => {
  return dispatch => {
    dealService.addDealLocation(formdata, dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));

      }
    );
  };

  function request(data) {
    return { type: dealConstants.ADD_DEALLOC_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.ADD_DEALLOC_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.ADD_DEALLOC_FAILURE, error };
  }
};

export const getDealList = formData => {
  return dispatch => {
    dealService.getDealCurrent(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALCURRENT_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALCURRENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALCURRENT_FAILURE, error };
  }
};

export const getProductList = formData => {
  return dispatch => {
    dealService.getProductCurrent(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALCURRENT_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALCURRENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALCURRENT_FAILURE, error };
  }
};

export const getAuctionList = formData => {
  return dispatch => {
    dealService.getAuctionCurrent(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALCURRENT_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALCURRENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALCURRENT_FAILURE, error };
  }
};

export const getDealPending = formData => {
  return dispatch => {
    dealService.getDealPending(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPENDING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPENDING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPENDING_FAILURE, error };
  }
};

export const getProductPending = formData => {
  return dispatch => {
    dealService.getProductPending(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPENDING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPENDING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPENDING_FAILURE, error };
  }
};

export const getAuctionPending = formData => {
  return dispatch => {
    dealService.getAuctionPending(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPENDING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPENDING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPENDING_FAILURE, error };
  }
};

export const getDealUpcoming = formData => {
  return dispatch => {
    dealService.getDealUpcoming(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALUPCOMING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALUPCOMING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALUPCOMING_FAILURE, error };
  }
};

export const getProductUpcoming = formData => {
  return dispatch => {
    dealService.getProductUpcoming(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALUPCOMING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALUPCOMING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALUPCOMING_FAILURE, error };
  }
};

export const getAuctionUpcoming = formData => {
  return dispatch => {
    dealService.getAuctionUpcoming(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALUPCOMING_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALUPCOMING_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALUPCOMING_FAILURE, error };
  }
};

export const getDealPast = formData => {
  return dispatch => {
    dealService.getDealPast(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPAST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPAST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPAST_FAILURE, error };
  }
};

export const getProductPast = formData => {
  return dispatch => {
    dealService.getProductPast(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPAST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPAST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPAST_FAILURE, error };
  }
};

export const getAuctionPast = formData => {
  return dispatch => {
    dealService.getAuctionPast(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALPAST_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALPAST_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALPAST_FAILURE, error };
  }
};

export const deleteDeal = dealID => {
  return dispatch => {
    dealService.deleteDeal(dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.DELETE_DEAL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.DELETE_DEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.DELETE_DEAL_FAILURE, error };
  }
};

export const deleteImage = id => {
  return dispatch => {
    dealService.deleteImage(id).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.DELETE_IMAGE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.DELETE_IMAGE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.DELETE_IMAGE_FAILURE, error };
  }
};

export const deleteDealLocation = (dealID, dealLocationID) => {
  return dispatch => {
    dispatch(request());
    dealService.deleteDealLocation(dealID, dealLocationID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.DELETE_DEAL_LOCATION_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.DELETE_DEAL_LOCATION_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.DELETE_DEAL_LOCATION_FAILURE, error };
  }
};

export const getDealDetail = dealID => {
  return dispatch => {
    dealService.getDealDetail(dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALDETAIL_FAILURE, error };
  }
};

export const getAllCategory = formData => {
  return dispatch => {
    categoryService.getAllCategory(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_REQUEST, allcategory };
  }
  function success(allcategory) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_SUCCESS, allcategory };
  }
  function failure(error) {
    return { type: categoryConst.VIEW_ALL_CATEGORY_FAILURE, error };
  }
};

export const getOrderDeatil = dealID => {
  return dispatch => {
    dealService.getOrderDeatil(dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALORDER_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALORDER_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALORDER_FAILURE, error };
  }
}
export const getDealCities = () => {
  return dispatch => {
    dealService.getDealCities().then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALCITIES_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALCITIES_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALCITIES_FAILURE, error };
  }
};

export const confirmClose = formData => {
  return dispatch => {
    dealService.confirmClose(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.CONFIRM_CLOSE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.CONFIRM_CLOSE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.CONFIRM_CLOSE_FAILURE, error };
  }
};
export const uploadExternalVoucher = formData => {
  return dispatch => {
    dealService.uploadExternalVoucher(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.POST_EXTERNAL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.POST_EXTERNAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.POST_EXTERNAL_FAILURE, error };
  }
};
export const getExternalVoucher = formData => {
  return dispatch => {
    dealService.getExternalVoucher(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.POST_UPEXTERNAL_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.POST_UPEXTERNAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.POST_UPEXTERNAL_FAILURE, error };
  }
};

export const getDealSchedule = formData => {
  return dispatch => {
    dealService.getDealSchedule(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALSCHEDULE_FAILURE, error };
  }
};

export const getProductSchedule = formData => {
  return dispatch => {
    dealService.getProductSchedule(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALSCHEDULE_FAILURE, error };
  }
};

export const getAuctionSchedule = formData => {
  return dispatch => {
    dealService.getAuctionSchedule(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALSCHEDULE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALSCHEDULE_FAILURE, error };
  }
};

export const updateAttribute = formData => {
  return dispatch => {
    dealService.updateAttribute(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.POST_ATTRIBUTE_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.POST_ATTRIBUTE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.POST_ATTRIBUTE_FAILURE, error };
  }
};

export const updateQuantity = formData => {
  return dispatch => {
    dealService.updateQuantity(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.UPDATE_QUANTITY_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.UPDATE_QUANTITY_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.UPDATE_QUANTITY_FAILURE, error };
  }
};


export const getChildDeals = formData => {
  return dispatch => {
    dealService.getChildDeals(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_CHILDDEALS_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_CHILDDEALS_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_CHILDDEALS_FAILURE, error };
  }
};


export const getDealContract = formData => {
  return dispatch => {
    dealService.getDealContract(formData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealConstants.GET_DEALCONTRACT_REQUEST, data };
  }
  function success(data) {
    return { type: dealConstants.GET_DEALCONTRACT_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealConstants.GET_DEALCONTRACT_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/dealActions.js